module.exports = __webpack_public_path__ + "static/Lato-SemiboldItalic-80f6811f6c30735dab68a01372d8b78f.woff2";